import React, { createContext, useContext, useEffect, useState } from "react";
import API from "../api";

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("adl_token");
    if (token) {
      API.get("/auth/me")
        .then((r) => setUser(r.data))
        .catch(() => localStorage.removeItem("adl_token"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await API.post("/auth/login", { email, password });
    localStorage.setItem("adl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await API.post("/auth/register", payload);
    localStorage.setItem("adl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const refresh = async () => {
    try {
      const r = await API.get("/auth/me");
      setUser(r.data);
    } catch {
      /* noop */
    }
  };

  const logout = () => {
    localStorage.removeItem("adl_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};
